import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { cn } from '../utils/cn';
/**
 * Neutraler Layout-Container (MUI-`Box`-Ersatz). Reicht alle DOM-Props durch und
 * traegt keine eigenen Styles — Abstaende/Layout kommen ueber `style`/`className`
 * bzw. die spezialisierten Layout-Komponenten (`Stack`, `Divider`).
 */
export const Box = forwardRef(function Box({ as = 'div', className, ...rest }, ref) {
    const Tag = as;
    return _jsx(Tag, { ref: ref, className: cn(className), ...rest });
});
